<template>
  <div class="user_page">
    <div class="d-flex align-center justify-space-between mb-3">
      <h3 class="title-page">{{ $t("movingProducts") }}</h3>
      <button class="infoVideo" @click="openInfoVideoModal">
        <span class="text-primary cursor-pointer">{{
          $t("videoInstruction")
        }}</span>
      </button>
    </div>
    <div>
      <div class="admin_container">
        <v-btn
          @click="openModal"
          class="mb-3"
          color="primary"
          style="text-transform: capitalize"
          v-if="permission.MOVE_PRODUCT"
        >
          <v-icon size="medium" class="mr-1">mdi-plus-circle</v-icon>
          {{ createButtonLoading ? $t("loading") : $t("create") }}
        </v-btn>
        <div class="table_cover">
          <table-with-filter
            :is-filterable="false"
            :items="items"
            :headers="headers"
            fixed-header
          >
            <template
              #item.warehouseName="{
                /**
                 * @type {Object}
                 * @property {string} oldWarehouseName
                 * @property {string} warehouseName
                 */
                item,
              }"
            >
              <div style="font-weight: 600">
                {{ item.oldWarehouseName }} - {{ item.warehouseName }}
              </div>
            </template>
            <template #item.state="{ item }"
              >{{ $t(`moveProductStatus.${item.state}`) }}
            </template>
            <template #item.productName="{ item }"
              >{{ item[`productName_${$i18n.locale}`] }}
            </template>
            <template #item.action="{ item }">
              <v-btn
                v-if="item.state === 'NEW'"
                @click="$refs.omtkMoveProductInfoDialog.open(item)"
                class="new_style"
              >
                <vue-icon icon="newCheckIcon"></vue-icon>
              </v-btn>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          @update:limit="
            (limit) => {
              params.limit = limit;
              params.page = 1;
              changePage();
            }
          "
          v-model="params.page"
          :length="lastPage"
          @input="changePage"
          go-to
          :limit="params.limit"
        />
      </div>
    </div>
    <omtk-move-product-info-dialog
      @UPDATED="getItems"
      ref="omtkMoveProductInfoDialog"
    ></omtk-move-product-info-dialog>
    <v-dialog style="background: #fff" v-model="dialog" max-width="400px">
      <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(openPlacementDialog)">
          <v-card>
            <div
              class="d-flex align-center"
              style="
                justify-content: space-between;
                border-bottom: 1px solid #dfe2e9;
              "
            >
              <v-card-title>{{ $t("create") }}</v-card-title>
              <span
                @click="closeDialog"
                class="mr-4 cursor-pointer"
                style="height: 16px"
              >
                <vue-icon icon="newBoldCloseIcon" />
              </span>
            </div>
            <v-card-text class="warehouse_modal zone_attach product_move">
              <div>
                <span
                  style="
                    color: #48545d;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                  "
                  >{{ $t("fromWhichWarehouse") }}
                </span>
                <vue-select
                  :item-text="vueSelectName"
                  infinite
                  rules="required"
                  :name="`${$t('selectWarehouse')}.`"
                  prepend-icon="warehouseTypeIcon"
                  :placeholder="$t('selectWarehouse')"
                  ref="warehouseListSelect"
                  v-model="formData.fromWarehouseId"
                  :items="warehousesFrom"
                  @blur="getWarehousesAll"
                  @changeText="getWarehousesAll"
                  @CHANGE_VALUE="valueSelected"
                  clearable
                  class="user_input no-margin mt-2"
                >
                </vue-select>
              </div>
              <div class="mt-2">
                <span
                  style="
                    color: #48545d;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                  "
                  >{{ $t("whichWarehouse") }}
                </span>
                <vue-select
                  :item-text="vueSelectName"
                  infinite
                  rules="required"
                  :name="$t('selectWarehouse')"
                  prepend-icon="warehouseTypeIcon"
                  :placeholder="$t('selectWarehouse')"
                  v-model="formData.toWarehouseId"
                  @changeText="getWarehousesAll"
                  @blur="getWarehousesAll"
                  :items="warehouseTo"
                  clearable
                  class="user_input no-margin mt-2"
                >
                </vue-select>
              </div>
              <div class="mt-2">
                <span
                  style="
                    color: #48545d;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                  "
                  >{{ $t("selectProduct") }}
                </span>
                <vue-select
                  ref="ProductSelectRef"
                  infinite
                  rules="required"
                  :name="$t('selectProduct')"
                  prepend-icon="warehouseTypeIcon"
                  :placeholder="$t('selectProduct')"
                  @CHANGE_VALUE="selectProduct"
                  @changeText="setProducts"
                  v-model="formData.productId"
                  :items="products"
                  clearable
                  class="user_input no-margin mt-2"
                >
                </vue-select>
              </div>
              <div v-if="selectedProductData.length">
                <div class="mt-5">
                  <span class="modal_subtitle">{{ $t("productName") }}</span>
                  <span class="modal_product_title">{{
                    selectedProductData[0].name
                  }}</span>
                </div>
                <div class="mb-4">
                  <span class="modal_subtitle">{{ $t("totalQuantity") }}</span>
                  <span class="modal_product_title">{{
                    totalProductCount
                  }}</span>
                </div>

                <div
                  class="mt-3 mb-5"
                  style="padding-bottom: 20px; border-bottom: 1px solid #dfe2e9"
                >
                  <span class="modal_product_title">{{
                    $t("positionStillage")
                  }}</span>
                  <div class="carriage_about_container">
                    <div class="d-flex align-center" style="gap: 5px">
                      <div class="carriage_box"></div>
                      <span>- stillage box</span>
                    </div>
                    <div class="d-flex align-center" style="gap: 5px">
                      <div class="carriage_box stellage"></div>
                      <span>- carriage box</span>
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in selectedProductData"
                    class="counter_container mt-3"
                    :key="item.id"
                  >
                    <div class="carriage_box mr-1">
                      {{ item.stillageAddress }}
                    </div>
                    <div class="carriage_box stellage">
                      {{ item.carriageAddress }}
                    </div>
                    <div class="count_product">
                      <span>{{ Number(item.count) }}</span>
                      <span>{{ item[`unit_type_name_${$i18n.locale}`] }}</span>
                    </div>
                    <custom-input-text
                      :placeholder="$t('writeQuantity')"
                      only="number"
                      @input="calculateSum"
                      :name="$t('count')"
                      rules="required"
                      v-model="placementProductCounts[index].value"
                    >
                    </custom-input-text>
                  </div>
                </div>
                <div style="display: flex; gap: 10px">
                  {{ $t("totalQuantity") }}:
                  <span style="font-weight: 600; display: flex"
                    >{{ sumOfProductCount ? sumOfProductCount : 0 }}
                    <pre style="margin-left: 4px">{{
                      selectedProductData[0][`unit_type_name_${$i18n.locale}`]
                    }}</pre>
                  </span>
                </div>
              </div>
              <div class="mt-3">
                <v-btn
                  :disabled="sumOfProductCount > totalProductCount"
                  width="100%"
                  type="submit"
                  color="primary"
                  >{{ $t("save") }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-form>
      </validation-observer>
    </v-dialog>
    <DeterminePlacement
      ref="determinePlacementDialogRef"
      :productItems="selectedProductData"
      :productItemIds="selectedProductItemIds"
      :selectedProductId="selectedProductId"
      @place-here="getItems"
      @clearProductItemIds="clearProductItemIds()"
    ></DeterminePlacement>
    <v-dialog max-width="700px" v-model="infoVideoModal">
      <v-card style="padding: 10px 20px">
        <h4 class="mb-2">{{ $t("movingproducts") }}</h4>
        <video
          class="videoPlayer"
          style="width: 100%; height: 100%"
          muted
          autoplay
          controls
          controlslist="nodownload"
        >
          <source src="@/assets/img/video/moveproduct.mp4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import { getQueryPage, makerPagination } from "@/utils/pureFunctions.js";
import OmtkMoveProductInfoDialog from "@/components/omtk/OmtkMoveProductInfoDialog.vue";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";
import VueSelect from "@/components/ui/vue-select/VueSelect.vue";
import DeterminePlacement from "@/components/omtk/DeterminePlacement.vue";
import http from "@/plugins/Axios";

const DEFAULT_PRODUCT_PLACEMENT_DATA = {
  fromWarehouseId: null,
  toWarehouseId: null,
  productId: null,
  productCount: null,
};

export default {
  data() {
    return {
      permission: {
        MOVE_PRODUCT: false,
      },
      dialog: false,
      totalProductCount: null,
      selectedProductId: null,
      createButtonLoading: false,
      infoVideoModal: false,
      meData:
        "XTNipgaYT1SD9HFSpdPFPYUPs51MRk9d+3J3WxRPh7+0Qe5BmB7DiYkPVQ+Pc3ZDiG9JIaBLyEoC2KJKiJaoa6zBYwCqN4bmXiEtZovs53Q+1t7DwPE79P6sda9kYJEMpsWAz9FAHV3EMOWA5iTfYafC7sJLXIHBIx4lxJ9WIijd6Ot4EvUnHz9LWFCJlAQEq+bByVR5WMiB2nf0m0RinbVnXS46U9b9HW9IyqfRM5jWTudvWrGLPQ/zN+wO2zKe0d4OeIBldwEoM/rv8JyqczT0oozdpWyS/1FXjBqCij0jyOqGUTZdSSxtrLhVMISb/p2l0N2irFcooKRhjZhgb8i1rd9afBWWrHDHgtrgJra/EaZUme3M1Oael7ZBYZukGB2n52NngBxvBhpT/VHxTC9hadMak6+dl7dcscUbutY4KHk6SgJ+6qlRbayvbd7f2FctMhOehBwH3wJ7sofrw6z7+Bh6r+oaHB5pKtoIKwvFG4pnKAR0acLqUbtcmkyd0a0/tQ0tKedWCljrQUSn9bWhtzdu0+Mg5HSHne900arAXbP33CM3IpSqXQsXvzxYvSAjeHhgjTnN6MEWS8p+VlgeKyskjHIyBKU2ZSKK52NsmWzCDIp0cg4kiOZ5ksiOrxLOfRlzrsYgVzEavdhJrExm9Ykxo2qc1Dmlf+9L5M07aYUVaZAPt22Z9JJlIBVDSqpasyLofAmKmOGxnadJAxi/hNgpJPDVSpGFeyUf+SSAf0LmvEx8tKLuNFwc/umVzVXXr6XaUVza+dViyWc7E2JjeKYld9emZMgyW4gKEFzAPExLxlghWtee6SAUVxxM0sqqk5M3EuD5YM1GQ3De8WGk80lzaBdWoq+8iSCPcWGJXJqKwqcthLZ8Nph0QCj4/JMamX8W4gUYaKBJQ4b5+LbFxNj3DXKiIusJyYd7/Lr0u7lCLoi7tTkQnm/OSYqKWlCmnGkJJRmZXNUHuIo9a0mIMJknN4txhIffRz1p/fyG9ilO8OBV4SCRXpUtrXvQTqJU5Dy8fnvMDXjc7uP4O+KMFJDTLP59zEptIegKrdZXfai5ilkthlMT32vvjHn7kSnjixGVhXZN8oL3N7XKOVH3KtMji+Le9yGxi9BKeF+BrCafGQgO1uehdS652M7V15y9n8OgbLech9MsB4zID5sewe8frk4Fh1M6daIBoYs/S766KxDKKJCRajRZ4bX65+hzs9KGRESLHPFWvDdSD/KAzM7Z7/kcJVtFDzfABNxEdDTngR5uxg2OdfTxfRIxoYpy6ahB2G0adozpHJ/YxTxV1B7aMDbaVCWlNqUL1EQkZHMo82k7VTB3AcDl/c+ZXY5FGHLCidmoHPG81nsKUFcHqeLZtpTKYubZzmAXwI2tUK3uDJeYbImfPTTod7gJ3Bosx7w/+1NaBmgkkLnKm2UgZe7qyGqnd2iLAS/+9Qxs7T7Tbi71MWNnjAHkFqr7PuYDctGf3x9eltN686MihwT7VtQdKkDHgYGYA9511Q64Eca7zz2nj4toSo5oV6U+C0smY9p1LvblPxI3xWpOXSW0IuCsMuflDU6dz/b6FWYX3oRwzkoMR/GIKSXfgDuQtvDYDZmx1gxQ2zM3YTrmtOqVMkEYQZQh8OrPzML+MqtaSBchmjDXciTJgNlTh9FsuKxof9NcOOCf6NpHuVjoGe9ceu6mqx2uzPrFNjgCxIrLxM9qwLDNev32Km+GBLjHrhcpSlNp6iYbTojBsbGyKFqecd+vHUhWvafIcfww+JhQp58wO4n/Qqcms8FhzwUkhixqwo+gRQxhe/xlYi177Xy8HzTg/qgO0YiLsxEZMUHhW7gIBx5TZSdEwOtQhqqWslHJWFooojHiwmODflpXaQgW5aIuPWhbiyaaHRye8uyxY7k2Gr+yDjbT+EahOP2V5kN4xuNe+sIuago9EEdNwJqFopdoySmaI7LccQdMyNy+V47knLjy2CNupAUT2ALFaED3DfqVtBoT/lscXsGRx9N03/ebAaOrx/w13J18sll7bgiD7UcRW6EPq2pDtwQCF6wpytylzvtu1bcnG7UkAcUIDcYUFP1Hr5dXDjtiJpNo76y8VzHBuEJJ0/RufIVoWCd9EiVFaZ0O+v2xsnoLBYA317zf7wmf58tY75fZRY58f2Fe787aPHiIy8yrf2Up8jnkI0qUFOZNx2M1Sa2ND80QEtNgxzGehntvyyJCyVyaO39H+0pZ4rE8R3GIhgrlqh5/9RYyreeoezj88Ld/TxwNR5retFavu8nsPfCwgANhsL/pIzxpuUDBZUcE0GAEQgUk9HJdA9dORMVEkROQPDDbPxihlJ7FlFdunc/v2EFBmDGuEstSB5IozIOSFmvgD8EJ3SV28DfNuIRNV/PXS12oHz5CQtSKuGgSdXGrZbuaHWvoBOL41/PnXNvOOmDulxmKNDoGikQ0R9sJQEd+irB3tndr/IF+xYA/g/WiKolxUCCAyni76suxkUDtb2XsYUOtGHLNWQLVw+gOIiX/gXhoihQvXnMI0F8YCuFpt8Gu0sMcd3LOxXJuR7gl2vG936/NlXnxtDhfW7eqjuurARMnacjIdUWEltZ41qPxDLSVw9SuxzHEXR6Eck591cyiTr6GFuL58zLP4zcD75ItzaaxZwqp29J8Jwg5O+Yde331qggdfWTRQ8Tk3bHLKW6V",
      selectedProductData: [],
      selectedProductItemIds: [],
      warehousesFrom: [],
      warehouseTo: [],
      placementProductCounts: [],
      sumOfProductCount: null,
      products: [],
      formData: {
        ...DEFAULT_PRODUCT_PLACEMENT_DATA,
      },
      params: {
        limit: 5,
        page: 1,
      },
      lastPage: 0,
      items: [],
    };
  },
  components: {
    DeterminePlacement,
    VueSelect,
    OmtkMoveProductInfoDialog,
    TableWithFilter,
    VuePagination,
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("warehouse"),
          value: "warehouseName",
        },
        {
          text: this.$t("name"),
          value: "productName",
        },
        {
          text: this.$t("state"),
          value: "state",
        },
        {
          text: this.$t("comment"),
          value: `comments_${this.$i18n.locale}`,
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        // {
        //   text: this.$t("action"),
        //   value: "action",
        // },
      ];
    },
  },
  methods: {
    /**
     * @param page {number}
     */
    openInfoVideoModal() {
      this.infoVideoModal = true;
    },
    checkVideoOpenedBefore() {
      if (localStorage.getItem("movingproductsInfo")) {
        return;
      }

      setTimeout(() => {
        this.openInfoVideoModal();
        localStorage.setItem("movingproductsInfo", "true");
      }, 2000);
    },
    async changePage(val) {
      this.showLoading();
      await this.$router.replace({ query: { page: val } });
      await this.getItems();
      this.clearLoading();
    },
    vueSelectName(item) {
      if (item.value === "BLACK") {
        return `${item.name} / ${item.value}`;
      } else {
        return item.name;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.formData = {
        ...DEFAULT_PRODUCT_PLACEMENT_DATA,
      };
      this.$refs.validationObserver.reset();
      this.resetValues();
    },
    async openModal() {
      this.createButtonLoading = true;
      await this.getWarehousesAll();
      this.dialog = true;
      this.createButtonLoading = false;
    },
    resetValues() {
      this.products = [];
      this.$refs.ProductSelectRef.reset();
      this.placementProductCounts = [];
      this.selectedProductData = [];
    },
    async getItems() {
      try {
        const params = {
          ...this.params,
          page: this.params.page - 1,
        };
        const {
          data: { data, total, permissions },
        } = await this.$http.get("/product-to-warehouse-application/list", {
          params,
        });
        this.permission = permissions;
        this.lastPage = makerPagination({
          limit: params.limit,
          total,
        }).lastPage;
        this.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    clearProductItemIds() {
      this.productItemIds = [];
      this.formData.toWarehouseId = null;
      this.$refs.determinePlacementDialogRef.close();
    },
    openPlacementDialog() {
      this.selectedProductItemIds = this.selectedProductData.map(
        (item, index) => {
          return {
            id: item.id,
            movedCount: this.placementProductCounts[index].value,
          };
        }
      );
      const { determinePlacementDialogRef } = this.$refs;
      if (determinePlacementDialogRef) {
        determinePlacementDialogRef.open(
          this.formData.toWarehouseId,
          this.formData.fromWarehouseId
        );
      }

      this.closeDialog();
    },
    async setProducts(name = "") {
      if (this.selectedProductData) {
        this.selectedProductData = [];
      }
      const id = this.formData.fromWarehouseId;
      const params = { warehouseId: id, name };
      const {
        data: { data: dataProduct, permissions },
      } = await http.get("product/by-warehouse", {
        params,
      });
      this.permission = permissions;
      this.products = dataProduct;
    },
    async selectProduct(item) {
      this.selectedProductId = item.id;
      try {
        const params = {
          productId: item.id,
          warehouseId: this.formData.fromWarehouseId,
        };
        const {
          data: { data, permissions },
        } = await this.$http.get("/product-item/list", {
          params,
        });

        this.permission = permissions;
        this.selectedProductData = data;
        this.generateDataArray();
        this.totalProductCount = this.selectedProductData.reduce(
          (sum, product) => sum + parseInt(product.count, 10),
          0
        );
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    generateDataArray() {
      for (let i = 0; i < this.selectedProductData.length; i++) {
        this.placementProductCounts.push({
          id: this.selectedProductData[i].id,
          value: null,
        });
      }
    },
    saveAttribute() {
      console.log(this.formData);
    },
    setWarehousesFrom(warehouse) {
      if (this.selectedProductData) {
        this.selectedProductData = [];
      }
      // this.resetValues();
      this.warehousesFrom = warehouse;
    },
    setWarehouseTo(warehouse) {
      this.warehouseTo = warehouse;
    },
    calculateSum() {
      this.sumOfProductCount = this.placementProductCounts.reduce(
        (sum, item) => sum + parseFloat(item.value) || 0,
        0
      );
    },
    async getWarehousesAll(name = "") {
      const params = { name };
      const {
        data: { data },
      } = await http.get("warehouse/items", { params });

      this.setWarehousesFrom(data);
      this.setWarehouseTo(data);
    },
    valueSelected() {
      this.getWarehousesAll();
    },
  },
  watch: {
    placementProductCounts: {
      deep: true,
      handler: function () {
        this.calculateSum();
      },
    },
    formData: {
      deep: true,
      handler: function () {
        this.setProducts();
      },
    },
  },
  async created() {
    const { page } = this.$route.query;
    this.params.page = getQueryPage(page);
    this.showLoading();
    await this.getItems();
    this.clearLoading();
    this.checkVideoOpenedBefore();
  },
};
</script>

<style lang="scss" scoped>
.modal_subtitle {
  color: #a2a5b9;
  font-size: 11px;
  font-weight: 400;
  display: block;
}

.modal_product_title {
  color: #48545d;
  font-size: 14px;
  font-weight: 500;
}

.carriage_box {
  color: #000;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: rgba(240, 161, 38, 0.24);
  display: flex;
  justify-content: center;
  align-items: center;
}

.carriage_box.stellage {
  background: #df826c;
}

.count_product {
  span {
    color: #a2a5b9;
    font-size: 14px;
  }

  span:first-child {
    margin-right: 5px;
    color: #48545d;
    font-size: 16px;
  }
}

.counter_container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.carriage_about_container {
  display: flex;
  gap: 8px;
}

.text-primary {
  color: rgb(0 150 178);
  &:hover {
    color: #fff;
  }
}

.infoVideo {
  padding: 8px 24px;
  border-radius: 6px;
  transition: 0.3s ease;
  background: rgba(42, 187, 222, 0.33);
  //width: 200px;

  span {
    transition: 0.2s ease;
  }

  &:hover {
    background: #0096b2;

    span {
      color: #fff;
    }
  }
}
</style>
